export const INVALID_EMAIL_ERROR_MESSAGE = 'Enter the format name@example.com';

export const REQUIRED_EMAIL_MESSAGE = 'Please enter your email';
export const EMAIL_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,24}$/;
